import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  OnDestroy,
  Input
} from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EINVOICE_PAYM } from '@core';
import { SEModule } from '@delon/abc/se';
import { ACLService } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { Store } from '@ngrx/store';
import { SharedModule } from '@shared';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {
  NzTreeSelectComponent,
  NzTreeSelectModule
} from 'ng-zorro-antd/tree-select';
import { forkJoin, map, Subject, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { accountIsCreatedAction } from 'src/app/actions/account';
import { CurrencySelectComponent } from 'src/app/components/select/currency-select/currency-select.component';
import { TariffTaxCodeSelectComponent } from 'src/app/components/select/tariff-tax-code-select/tariff-tax-code-select.component';
import { FormService } from 'src/app/core/util/form.service';
import { AutoFocusInputDirective } from 'src/app/shared/directives/auto-focus-input.directive';
import { CreateApiResponse } from 'src/app/shared/types/accounts';

@Component({
  selector: 'app-account-code-modal',
  templateUrl: './account-code-modal.component.html',
  styleUrls: ['./account-code-modal.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzInputModule,
    SEModule,
    NzToolTipModule,
    NzModalModule,
    NzTableModule,
    NzIconModule,
    NzDropDownModule,
    NzSpinModule,
    NzTreeSelectModule,
    NzSelectModule,
    NzRadioModule,
    TariffTaxCodeSelectComponent,
    NzSwitchModule,
    NzTabsModule,
    NzGridModule,
    CurrencySelectComponent,
    SharedModule
  ]
})
export class AccountCodeComponent implements OnInit, OnDestroy {
  @ViewChild('form') form!: NgForm;
  @ViewChild('treeSelect') treeSelect!: NzTreeSelectComponent;
  @ViewChild('autoFocus') autoFocusDirective!: AutoFocusInputDirective;
  activeTab = 0;
  loading = false;
  isSaving = false;
  isMobileView: boolean = false;
  @Input() initSpecialCode: string = '';
  @HostListener('window:resize')
  onResize() {
    this.isMobileView = window.innerWidth <= 1024;
  }

  get shouldShowPaymentMethod() {
    return (
      !this.model.hasChildren &&
      (this.model.specialCode === 'BAC' || this.model.specialCode === 'BOAC')
    );
  }
  get shouldShowSettings() {
    return (
      !this.model.hasChildren &&
      (this.model.specialCode === 'BAC' || this.model.specialCode === 'BOAC')
    );
  }
  data: any = [];
  formats: any = {
    cheque: [],
    payment: [],
    receipt: []
  };

  @Output() readonly submitted = new EventEmitter<any>();

  specialCodes = [
    { value: '', label: 'None' },
    { value: 'ADA', label: 'Accumulated Depreciation Account' },
    { value: 'APLAC', label: 'Accumulated Profit & Loss' },
    { value: 'BAC', label: 'Bank Account' },
    { value: 'BOAC', label: 'Bank Overdraft Account' },
    { value: 'CAC', label: 'Cash Account' },
    { value: 'CCAC', label: 'Creditors Control Account' },
    { value: 'CST', label: 'Closing Stock' },
    { value: 'DAC', label: 'Debtors Control Account' },
    { value: 'MAC', label: 'Manufacturing Account' },
    { value: 'OST', label: 'Opening Stock' },
    { value: 'PT', label: 'Purchases Tax' },
    { value: 'SAC', label: 'Stock Account' },
    { value: 'ST', label: 'Sales Tax' },
    { value: 'DP', label: 'Deposit Account' }
  ];
  displayedCodes: any[] = [];
  model: any = {};
  private _accountType: any;

  get accountType() {
    return this.model.accountType;
  }

  set accountType(value: any) {
    this.model.accountType = value;
  }

  visible: boolean = false;
  country: string = 'MY';
  accTypes: any[] = [];
  parentId: any;
  parent: any = {};
  inUse: boolean = false;
  modified: boolean = false;
  isInstantData: boolean = false;
  interval$: NzSafeAny;
  /** Last saved parent selection; used for revert and currency-change confirmation when editing */
  parentIdBaseline: string | null = null;

  paymentMethods: any[] = [...EINVOICE_PAYM];
  private destroy$ = new Subject<boolean>();

  get canCreate() {
    return this.acl.can({ ability: ['coa.create'] });
  }

  get canEdit() {
    return this.acl.can({ ability: ['coa.update'] });
  }

  constructor(
    private http: _HttpClient,
    private fs: FormService,
    private msg: NzMessageService,
    private modal: NzModalService,
    private acl: ACLService,
    private cdr: ChangeDetectorRef,
    private router: ActivatedRoute,
    private store: Store
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    return;
  }

  private loadList() {
    return new Promise<boolean>((resolve, reject) => {
      zip(
        this.http.get('api/companyProfile/countrycode'),
        this.http.get('api/accountTypes/all'),
        this.http.get(`api/chartofaccounts/tree`),
        this.http.get(`api/runningNumbers/ForBankCode`)
      ).subscribe({
        next: ([country, types, tree, chequeFormats]) => {
          this.country = country;
          this.accTypes = types;
          this.data = [...tree];
          this.splitFormats(chequeFormats);
          this.cdr.detectChanges();
          resolve(true);
        },
        error: () => {
          reject(false);
        }
      });
    });
  }

  splitFormats(formats: any) {
    this.formats = {
      cheque: formats.filter((o: any) => o.type === 'CHQN'),
      receipt: formats.filter((o: any) => o.type === 'OR'),
      payment: formats.filter((o: any) => o.type === 'PV')
    };
  }

  setEvent() {
    this.modified = false;
    this.interval$ = setInterval(() => {
      if (this.form) {
        this.form.valueChanges?.subscribe(() => {
          this.modified = true;
        });
        clearInterval(this.interval$);
      }
    }, 1000);
  }

  new(options: any) {
    // Kelvin: Do not remove this line, this is to force refresh the modal view
    this.visible = false;

    this.loading = true;
    this.visible = true;

    this.loadList()
      .then(() => {
        if (options && options.parentId) this.isInstantData = true;
        this.model = { ...options };

        if (!this.model.parentId && this.data.length > 0) {
          this.model.parentId = this.data[0].id;
        }
        
        // Use initSpecialCode input only for new accounts (when no existing specialCode in options)
        // This prevents overriding existing account data when editing
        if (this.initSpecialCode && !options.specialCode) {
          this.model.specialCode = this.initSpecialCode;
        } else if (!this.model.specialCode) {
          this.model.specialCode = '';
        }

        this.inUse = false;
        this.parentIdBaseline = this.model.parentId ?? null;

        setTimeout(() => void this.accountChanged(), 1);
        setTimeout(() => this.setEvent(), 500);

        this.loading = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
      
    this.loading = false;
    this.cdr.detectChanges();
  }

  edit(node: any) {
    // Kelvin: Do not remove this line, this is to force refresh the modal view
    this.visible = false;

    this.loading = true;
    this.visible = true;

    this.loadList()
      .then(() => {
        this.setEvent();
        if (node && node.id) {
          this.loading = true;
          this.getAccount(node.id)
            .then((res: any) => {
              this.loading = false;
              this.model = res;
              this.inUse = res.inUse;
              this.parentIdBaseline = res.parentId ?? null;
              this.filterSpecialCode(res.accountTypeId);

              setTimeout(() => this.setEvent(), 500);

              this.cdr.detectChanges();
            })
            .catch(() => {
              this.loading = false;
              this.cdr.detectChanges();
            });
        } else {
          this.loading = false;
          this.cdr.detectChanges();
        }
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  getAccount(id: string) {
    return new Promise((resolve, reject) => {
      this.http.get(`api/accountCodes/${id}`).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: () => {
          reject();
        }
      });
    });
  }

  cancel() {
    if (this.modified) {
      const modelRef = this.modal.confirm({
        nzTitle: 'Discard Changes?',
        nzContent: 'Changes you made may not be saved.',
        nzOnOk: () => {
          modelRef.close();
          this.form.resetForm();
          this.submitted.emit(null);
          this.visible = false;
        },
        nzOkText: 'Discard Changes',
        nzCancelText: 'Return'
      });
    } else {
      this.form.resetForm();
      this.submitted.emit(null);
      this.visible = false;
    }
  }

  submit(action: string) {
    if (!this.fs.validate(this.form).isValid) return;
    if (this.isSaving) return;

    this.isSaving = true;

    let requestUrl = this.model.id
      ? 'api/accountCodes/update'
      : 'api/accountCodes/create';

    if (!this.model.specialCode) this.model.specialCode = '';

    const body = { ...this.model };
    // avoid validation error from currency property
    delete body.currency;
    this.http.post(requestUrl, body).subscribe({
      next: (res: CreateApiResponse['data']) => {
        if (res?.parentId) {
          this.parentIdBaseline = res.parentId;
        }
        this.modified = false;
        this.isSaving = false;
        
        // Include initSpecialCode in the emitted data for validation
        const submittedData = {
          ...res,
          initSpecialCode: this.initSpecialCode
        };
        
        this.submitted.emit(submittedData);
        if (!this.model.id) {
          this.store.dispatch(accountIsCreatedAction({ newAccount: res }));
        }
        if (action === 'new') {
          this.form.resetForm();
          this.modified = false;

          setTimeout(() => {
            this.new({ parentId: this.model.accountTypeId, isActive: true });
            this.autoFocusDirective.focusManually();
          }, 50);
        } else if (action === 'close') {
          this.visible = false;
          this.form.resetForm();
        } else {
          this.model.id = res.id;
          this.modified = false;
        }
      },
      error: (err: any) => {
        this.isSaving = false;
        const m =
          err?.error?.message ||
          err?.message ||
          'Unable to save account.';
        this.msg.error(m);
      }
    });
  }

  specialCodeChanged(specialCode: any): void {
    this.updateCashFlowType();
  }

  updateCashFlowType() {
    if(this.model.cashFlowType)
      return;

    if (this.model.specialCode === 'BAC' || this.model.specialCode === 'CAC' || this.model.specialCode === 'BOAC') {
      this.model.cashFlowType = 0;
    } 

    // if (this.model.accountType) {
    //   if (
    //     [
    //       'BEQ',
    //       'BCL',
    //       'BLL',
    //       'BOL',
    //       'INC',
    //       'INA',
    //       'COG',
    //       'OTI',
    //       'EXP',
    //       'TAX'
    //     ].includes(this.model.accountType.code)
    //   ) {
    //     this.model.cashFlowType = 'operating';
    //   } else if (this.model.accountType.code === 'BCA') {
    //     // Special case for BCA - check special code
    //     if (['CAC', 'BAC', 'BOAC'].includes(this.model.specialCode)) {
    //       this.model.cashFlowType = 'none';
    //     } else {
    //       this.model.cashFlowType = 'operating';
    //     }
    //   } else if (['BFA', 'BLA'].includes(this.model.accountType)) {
    //     this.model.cashFlowType = 'investing';
    //   }
    // }
  }
  onParentModelChange(newParentId: string) {
    if (newParentId === this.parentIdBaseline) {
      return;
    }
    const previousParentId = this.parentIdBaseline;
    void this.accountChanged(previousParentId ?? undefined);
  }

  async accountChanged(previousParentId?: string) {
    this.loading = true;
    this.cdr.detectChanges();

    const priorCurrencyId = this.model.currencyId;
    const priorCurrency = this.model.currency;

    if (!this.model.parentId) {
      this.loading = false;
      this.cdr.detectChanges();
      return;
    }

    if (this.parent?.id) {
      const oldBranch: any = this.treeSelect.getTreeNodeByKey(this.parent.id);
      if (oldBranch?.origin) oldBranch.origin.disabled = false;
    }

    const branch: any = this.treeSelect.getTreeNodeByKey(this.model.parentId);
    if (!branch) {
      this.loading = false;
      this.cdr.detectChanges();
      return;
    }

    const node: any = branch.origin;
    node.disabled = true;

    const finishBaseline = () => {
      this.parentIdBaseline = this.model.parentId ?? null;
      this.updateCashFlowType();
      this.loading = false;
      this.cdr.detectChanges();
    };

    try {
      if (node.parentId) {
        const parentId = node.id;
        const parentAccount: any = await this.getAccount(parentId);
        if (!parentAccount) {
          this.msg.error('Invalid parent account');
          node.disabled = false;
          this.loading = false;
          this.cdr.detectChanges();
          return;
        }

        const currencyWillChange =
          !!this.model.id &&
          parentAccount.currencyId !== undefined &&
          priorCurrencyId !== undefined &&
          parentAccount.currencyId !== priorCurrencyId;

        const applyParent = async () => {
          this.loading = true;
          this.cdr.detectChanges();
          this.parent = parentAccount;
          await this.updateModelWithParentAccount(parentAccount, node);
          finishBaseline();
        };

        if (currencyWillChange) {
          this.modal.confirm({
            nzTitle: 'Currency will match parent',
            nzContent: `The selected parent account uses ${
              parentAccount.currency?.code ?? 'a different'
            } currency. This account's currency will be updated to match the parent.`,
            nzOnOk: () => applyParent(),
            nzOnCancel: () => {
              const revertTo = previousParentId ?? this.parentIdBaseline;
              if (revertTo) {
                this.model.parentId = revertTo;
              }
              this.model.currencyId = priorCurrencyId;
              this.model.currency = priorCurrency;
              node.disabled = false;
              void this.loadList().then(() => {
                this.loading = false;
                this.cdr.detectChanges();
              });
            }
          });
          this.loading = false;
          this.cdr.detectChanges();
          return;
        }

        this.parent = parentAccount;
        await this.updateModelWithParentAccount(parentAccount, node);
        finishBaseline();
        return;
      }

      this.parent = node;
      await this.updateModelWithoutParentAccount(node);
      finishBaseline();
    } catch (error) {
      console.error('Failed to get parent account:', error);
      node.disabled = false;
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  async updateModelWithParentAccount(parentAccount: any, node: any) {
    this.model.accountTypeId = parentAccount.accountTypeId;
    this.accountType = parentAccount.accountType; // Use the setter
    this.model.drcr = parentAccount.drcr;
    this.model.currencyId = parentAccount.currencyId;
    this.model.currency = parentAccount.currency;
    this.model.isActive = true;

    this.model.specialCode = node.specialCode;

    // if (!this.isInstantData) {
    // }

    this.filterSpecialCode(parentAccount.accountTypeId);
    
    // Only use initSpecialCode for new accounts (when no existing specialCode in node)
    // For existing accounts, preserve the current specialCode value
    if (this.initSpecialCode && !node.specialCode) {
      const isValidInitSpecialCode = this.displayedCodes.some(code => code.value === this.initSpecialCode);
      this.model.specialCode = isValidInitSpecialCode ? this.initSpecialCode : '';
    } else if (node.specialCode) {
      // For existing accounts, ensure the current specialCode is valid in the filtered list
      const isValidCurrentSpecialCode = this.displayedCodes.some(code => code.value === node.specialCode);
      if (!isValidCurrentSpecialCode) {
        this.model.specialCode = '';
      }
    }
    
    // Trigger change detection to update the view immediately
    this.cdr.detectChanges();
  }

  isBankOrCashAccount(account: any) {
    const specialCode = account.specialCode;
    return (
      specialCode === 'BAC' || specialCode === 'BOAC' || specialCode === 'CAC'
    );
  }

  updateModelWithoutParentAccount(node: any): Promise<void> {
    const accountTypeId = node.accountTypeId;
    return new Promise((resolve, reject) => {
      forkJoin({
        accountType: this.http.get(`api/accountTypes/${accountTypeId}`),
        localCurrency: this.http.get('api/currencies/local'),
        defaultTariff: this.http.get('api/tariffcodes/default')
      })
        .pipe(
          map(({ accountType, localCurrency, defaultTariff }) => {
            return { accountType, localCurrency, defaultTariff };
          })
        )
        .subscribe({
          next: ({ accountType, localCurrency, defaultTariff }) => {
            this.accountType = accountType; // Use the setter
            this.model.accountTypeId = accountType.id;
            this.model.drcr = accountType.drcr;
            this.model.specialCode = accountType.specialCode;
            this.model.currency = localCurrency;
            this.model.currencyId = localCurrency.id;

            if (defaultTariff?.id) {
              this.model.tariffCodeId = defaultTariff.id;
            }

            this.filterSpecialCode(accountType.id);
            
            // Only use initSpecialCode for new accounts (when no existing specialCode in model)
            // For existing accounts, preserve the current specialCode value
            if (this.initSpecialCode && !this.model.specialCode) {
              const isValidInitSpecialCode = this.displayedCodes.some(code => code.value === this.initSpecialCode);
              this.model.specialCode = isValidInitSpecialCode ? this.initSpecialCode : '';
            } else if (this.model.specialCode) {
              // For existing accounts, ensure the current specialCode is valid in the filtered list
              const isValidCurrentSpecialCode = this.displayedCodes.some(code => code.value === this.model.specialCode);
              if (!isValidCurrentSpecialCode) {
                this.model.specialCode = '';
              }
            }
            
            // Trigger change detection to update the view immediately
            this.cdr.detectChanges();
            resolve();
          },
          error: err => {
            //Handle error here
            console.error('Failed to load account data:', err);
            this.loading = false;
            this.cdr.detectChanges();
            reject(err);
          }
        });
    });
  }

  tariffCodeChanged(tariffcode: any) {
    if (tariffcode) {
      this.model.tariffCode = tariffcode;
      this.model.tariffCodeId = tariffcode.id;
    } else {
      this.model.tariffCode = null;
      delete this.model.tariffCodeId;
    }
  }

  filterSpecialCode(accountTypeId: string) {
    let accountType = this.accTypes.find((o: any) => o.id === accountTypeId);
    let typeCode = accountType.typeCode;
    console.log('filterSpecialCode called - accountTypeId:', accountTypeId, 'typeCode:', typeCode, 'current specialCode:', this.model.specialCode);

    switch (typeCode) {
      case 'BCA':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) =>
            o.value == 'BAC' ||
            o.value == 'CAC' ||
            o.value == 'DAC' ||
            o.value == 'SAC' ||
            o.value == 'PT' ||
            o.value == 'DP' ||
            o.value == ''
        );
        break;
      case 'BCL':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) =>
            o.value == 'BOAC' ||
            o.value == 'CCAC' ||
            o.value == 'ST' ||
            o.value == 'DP' ||
            o.value == ''
        );
        break;
      case 'COG':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) =>
            o.value == 'OST' ||
            o.value == 'CST' ||
            o.value == 'MAC' ||
            o.value == ''
        );
        break;
      case 'BEQ':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) => o.value == 'APLAC' || o.value == ''
        );
        break;
      case 'BFA':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) => o.value == 'ADA' || o.value == ''
        );
        break;
      case 'BLL':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) => o.value == 'BOAC' || o.value == ''
        );
        break;
      case 'INC':
      case 'INA':
      case 'OTI':
      case 'EXP':
      case 'TAX':
      case 'EOI':
      case 'EOE':
      case 'APP':
      case 'BIA':
      case 'BLA':
      case 'BOL':
        this.displayedCodes = this.specialCodes.filter(
          (o: any) => o.value == ''
        );
        break;
      default:
        this.displayedCodes = this.specialCodes;
        break;
    }

    // if (!this.model.specialCode && this.displayedCodes?.length > 0)
    //   this.model.specialCode = this.displayedCodes[0].value;
    
    // Trigger change detection to update the view immediately
    this.cdr.detectChanges();
  }

  changeCurrency() {
    if (this.model.currency) this.model.currencyId = this.model.currency.id;
  }

  convertToDisplay(value: any) {
    const item = this.paymentMethods.find((x: any) => x.value === value);
    if (item) {
      return `${item.value} - ${item.name}`;
    }
    return '';
  }

  autoBankParamChanged(type: 'cheque' | 'payment' | 'receipt', toggle: any) {
    if (!toggle || toggle === false) {
      if (type === 'cheque') {
        this.model.bankAccountChequeNumberEdit = false;
        this.model.bankAccountChequeNumberFormat = '';
      } else if (type === 'payment') {
        this.model.autoBankReceiptFormat = null;
      } else {
        this.model.autoBankPaymentFormat = null;
      }
    }
  }
}
